import {
  faBriefcase,
  faCertificate,
  faChartLine,
  faClock,
  faColumns,
  faHeadset,
  faHospital,
  faIdCard,
  faKey,
  faLaptopCode,
  faPallet,
  faPlug,
  faPuzzlePiece,
  faRunning,
  faShippingFast,
  faShoppingBag,
  faShoppingCart,
  faStore,
  faTachometerAlt,
  faToolbox,
  faTools,
  faUsers,
  faUserTie,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCodepen,
  faElementor,
  faFigma,
  faPhoenixFramework,
  faSketch,
} from "@fortawesome/free-brands-svg-icons";

export const SUBSERVICES = {
  react: [
    {
      icon: faPuzzlePiece,
      title: "Flexibility/Extensibility",
      body:
        "A flexible, quality and experienced React development process for your needs. Our agile development process is flexible and extensible for later modifications.",
    },
    {
      icon: faTachometerAlt,
      title: "Performance",
      body:
        "Our code is written clean and well manner with minimum external dependencies which provides maximum performence and well maintained code.",
    },
    {
      icon: faHeadset,
      title: "Communication",
      body:
        "We are always in touch with our customers within development cycle and accept feedback and make adjustments when possible.",
    },
    {
      icon: faClock,
      title: "Schedule",
      body:
        "We provide our work on time and when development time is unclear we try to finish our work as soon as possible.",
    },

    {
      icon: faRunning,
      title: "Service",
      body:
        "We provide after development service to our customers and provide solutions to various problems such as bug fixing, project extention/modifications.",
    },
    {
      icon: faToolbox,
      title: "Deployment",
      body:
        "We also provide deployment solutions to our customers which helps customers to avoid long and tiring process to deploy finished projects to servers.",
    },
  ],

  ecommerce: [
    {
      icon: faShoppingBag,
      title: "Ecommerce Application Development",
      body:
        "We build flawless e-commerce applications that own superb features. The list includes simple registration, push notifications and social media integration features.",
    },
    {
      icon: faPallet,
      title: "Custom Ecommerce Website Design",
      body:
        "Our professional developers create tailor-made e-commerce web design. They make sure that each of your specification is fulfilled from ideation to final store launch.",
    },
    {
      icon: faStore,
      title: "Online Store Development",
      body:
        "We are counted among top web development agencies in India. We create multichannel shopping portals that best serve your customers and leverage the venture to move ahead of the curve.",
    },
    {
      icon: faShoppingCart,
      title: "Ecommerce Cart Development",
      body:
        "We develop modern e-commerce shopping carts with the latest functionality, seamless navigation, SEO-friendly design and scalablility.",
    },
    {
      icon: faPlug,
      title: "Plug-In & Module Development",
      body:
        "Approach us to enhance your existing e-commerce websites with advanced plugins and modules. It will facilitate you with new market opportunities.",
    },
    {
      icon: faLaptopCode,
      title: "Web Development & Customization",
      body:
        "We provide customized e-commerce web & mobile solutions that cater your additional needs and make your e-store the best-selling online platform.",
    },
    {
      icon: faKey,
      title: "Payment Gateway Integration",
      body:
        "Being a credible software development company, we got expertise in integrating payment gateways like PayPal, WorldPay, Stripe, etc. This lets our customers securely proceed with their purchase.",
    },
    {
      icon: faTools,
      title: "Maintenance Support",
      body:
        "Our eCommerce development team is patient and helps you by conducting regular functionality checks. Afterward, they fix portal’s performance issues to make your online store flawless.",
    },
    {
      icon: faShippingFast,
      title: "Shipping Gateway Integration",
      body:
        "Being a web digital agency, we create e-commerce web design with UPS, DHL, USPS and FedEx shipping gateways to make product shipping & tracking easy.",
    },
  ],
  wordpress: [
    {
      icon: faUserTie,
      title: "Professional Website Development Services!",
      body:
        "We at  ITLIQUID facilitate our clients with end-to-end web development services. Our team manages the growing business needs of the clients. Our industry-oriented web designs are amazing and breathe more life into your existing brand image. And, we are sure about the quality of our design interfaces. Our designs are the optimal blend of usability and visibility.",
    },
    {
      icon: faUsers,
      title: "Dedicated Web Development Team!",
      body:
        "Experience award-winning web designs from us as we staffed the industry’s most skilled talent to cater your website related needs. Our team works on your project and leads it towards attaining a successful web design. They know that web design is more than embellishing an “About Us” and “Contact Us” page. Therefore, we create the entire website with an aim to make it compelling and completely communicable.",
    },
    {
      icon: faPuzzlePiece,
      title: "Flexible Web Design Process!",
      body:
        "Having a robust web design process in place helps you begin with a positive thought and overcome all the confusions along the way. As an agile methodology, we use PMS, Scrum and many other project management systems to execute the web design process with a vision of clarity & efficiency.",
    },
    {
      icon: faColumns,
      title: "Digitally Sound Web Interfaces!",
      body:
        "In this tough competitive environment, we are your web development partner who provides you a web optimized web design which further helps you incorporate internet marketing elements for better business growth. Simply, we render you the best website solutions that outshine over the web.",
    },
    {
      icon: faChartLine,
      title: "Rigorous Analysis & Accurate Reporting!",
      body:
        "The best web design is created with the help of proper planning, talent, experience and execution which our technicians always keep in mind. It’s our preferred choice to analyze the project and provide timely reporting so that things can under an agile environment.",
    },
  ],
  graphics: [
    {
      icon: faCodepen,
      title: "Business Logo Design",
      body:
        "It is one among our approaches to give a separate identity to businesses through logos that define the services in the best way.",
    },
    {
      icon: faFigma,
      title: "Logo Development",
      body:
        "The logo development services from our company majorly focus on providing a separate identity to a brand through exceptionally designed logos.",
    },
    {
      icon: faCertificate,
      title: "Brochure Designs",
      body:
        "Beautifully printed brochure designs that inspire users to own one among the pile of thousands other created by our designers.",
    },
    {
      icon: faBriefcase,
      title: "Corporate Logo Design",
      body:
        "The designs are created keeping to offer corporate identity to the business ranging from medium to larger business identities.",
    },
    {
      icon: faIdCard,
      title: "Business Cards Design",
      body:
        "We have helped a number of clients in showcasing their dynamic work profile over superbly design business cards.",
    },
    {
      icon: faHospital,
      title: "Company Logo Design",
      body:
        "A company’s logo is its true identity to represent among a crowd of millions of competitors. We create this identity sophisticatedly.",
    },
    {
      icon: faSketch,
      title: "Flyer Designs",
      body:
        "We create flyer designs to promote brands’ identity among the clients and the new users as well.",
    },
    {
      icon: faElementor,
      title: "Website Designs",
      body:
        "We are counted among industry leaders to provide website designs to the users. The designs are created to express business services.",
    },
    {
      icon: faPhoenixFramework,
      title: "Custom Logo Design",
      body:
        "Customizing the logos to suit to the specific needs of the clients come under our custom logo design services.",
    },
  ],
  seo: [
    {
      title: "Website Analysis",
      body:
        "Google Analytics lets you measure your advertising ROI as well as track your Flash and Social Networking sites.",
    },
    {
      title: "Keyword Research",
      body:
        "Keyword Research is one of the most important, valuable and high return activities in the search marketing.",
    },
    {
      title: "Competition Analysis",
      body:
        "Competitor Ananlysis in marketing strategic is an assessment of the weaknesses of competitors.",
    },
    {
      title: "Onsite Optimization",
      body:
        "Onsite SEO is the practice of optimizing elements of website in order to improve search engine rankings and visibility.",
    },
    {
      title: "Content Optimization",
      body:
        "Keyword research is a process of identifying the most important keywords for our website.",
    },
    {
      title: "Off Page Optimization",
      body:
        "Keyword research is a process of identifying the most important keywords for our website.",
    },
    {
      title: "Monitor Ranking",
      body:
        "Keyword research is a process of identifying the most important keywords for our website.",
    },
    {
      title: "Updating Content",
      body:
        "Keyword research is a process of identifying the most important keywords for our website.",
    },
  ],
};
